import React from 'react';
import { Helmet } from 'react-helmet-async';
import { seoConfig } from '../config';

const SEO = ({ 
  title = seoConfig.defaultTitle,
  description = seoConfig.defaultDescription,
  keywords = seoConfig.defaultKeywords,
  author = 'Tushar Singh',
  image = seoConfig.defaultImage,
  imageAlt = seoConfig.defaultImageAlt,
  url = seoConfig.siteUrl,
  type = 'website',
  noIndex = false,
  structuredData = null
}) => {
  const siteUrl = seoConfig.siteUrl;
  const fullUrl = url.startsWith('http') ? url : `${siteUrl}${url}`;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;
  const robotsContent = noIndex ? 'noindex, nofollow' : 'index, follow';
  const pageStructuredData = structuredData || {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url: fullUrl,
    inLanguage: 'en'
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content={robotsContent} />
      <meta name="googlebot" content={robotsContent} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:secure_url" content={fullImage} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="500" />
      <meta property="og:image:height" content="500" />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:locale" content={seoConfig.locale} />
      <meta property="og:site_name" content={seoConfig.siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:image:alt" content={imageAlt} />
      <meta name="twitter:creator" content={seoConfig.twitterHandle} />
      <meta name="twitter:site" content={seoConfig.twitterHandle} />
      <meta name="twitter:domain" content={siteUrl.replace(/^https?:\/\//, '')} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      <link rel="alternate" hrefLang="en" href={fullUrl} />

      {/* Structured Data */}
      <script type="application/ld+json">{JSON.stringify(pageStructuredData)}</script>
    </Helmet>
  );
};

export default SEO;
